import { getEncryptedIdFromPublicId, isPublicId, PublicId } from "./public-id";
import { getEncryptedUserIdFromPublicUserId, PublicUserId } from "./public-user-id";

export const publicTeamIdSuffix = "_tpuid";

export type PublicTeamId = PublicId<typeof publicTeamIdSuffix>;

export function getEncryptedTeamIdFromPublicUserId(publicUserId: PublicTeamId) {
  return getEncryptedIdFromPublicId(publicUserId, publicTeamIdSuffix);
}

export function isPublicTeamId(id: string | undefined | null): id is PublicTeamId {
  return isPublicId(id, publicTeamIdSuffix);
}

export function getPublicTeamIdFromPublicUserId(publicUserId: PublicUserId): PublicTeamId {
  return `${getEncryptedUserIdFromPublicUserId(publicUserId)}${publicTeamIdSuffix}`;
}
